import {validBaselineDraft,type BaselineDraftEntry} from '../customer-return-baseline/draft.ts';
export type EarlierReceiptDraft={productScan:string;notes:string;complete:boolean;entries:BaselineDraftEntry[]};
export const emptyEarlierReceiptDraft:EarlierReceiptDraft={productScan:'',notes:'',complete:false,entries:[]};
export function validEarlierReceiptDraft(value:unknown):value is EarlierReceiptDraft{
 if(!value||typeof value!=='object'||Array.isArray(value))return false;
 const d=value as Record<string,unknown>;
 return Object.keys(d).every(k=>['productScan','notes','complete','entries'].includes(k))&&typeof d.complete==='boolean'
  &&validBaselineDraft({productScan:d.productScan,reason:d.notes,recordsChecked:false,entries:d.entries})&&(d.entries as BaselineDraftEntry[]).every(e=>e.condition==='uninspected');
}
